export enum PlansPrice {
  LITE = "$0",
  STARTER = "$199",
  PLUS = "$249",
  ULTRA = "$349",
  STARTER_ANNUALLY = "$2028",
  PLUS_ANNUALLY = "$2544",
  ULTRA_ANNUALLY = "$3564",
}
